export const windowWidth = window.innerWidth;
export const windowHeight = window.innerHeight;

declare global {
  interface Window {
    resetEvent: Event;
    closePopupsEvent: Event;
    popupsClosedEvent: Event;
    popupOpenEvent: Event;
    qtyChangeEvent: Event;
    resetQtyEvent: Event;
    itemsLoadedEvent: Event;
  }
}
export function addEvent() {
  window.resetEvent = new Event("reset");
  window.closePopupsEvent = new Event("closePopups");
  window.popupsClosedEvent = new Event("popupsClosed");
  window.popupOpenEvent = new Event("popupOpen");
  window.qtyChangeEvent = new Event("qtyChange");
  window.resetQtyEvent = new Event("resetQty");
  window.itemsLoadedEvent = new Event("itemsLoaded");
}
export function appHeight() {
  const doc = document.documentElement
  doc.style.setProperty('--app-height', `${windowHeight}px`)
}

export function heightChange(){
  window.addEventListener('resize', appHeight)
}

export function isInView(el: HTMLElement | undefined) {
  if(!el) return
  const rect = el.getBoundingClientRect()
  return rect.top >= 0 && rect.bottom  <= window.innerHeight
}

export enum ShowHide {
  SHOW_MORE = 'Show More',
  SHOW_LESS = 'Show Less'

}